var Cookies = require('cookies-js');

let location = '';

$('.gated-resource').on('click', function(e) {
    e.preventDefault();

    location = $(this).data('resource');

    if (Cookies.enabled && !Cookies.get('gated-resource-cookie')) {
        $('#gated-resource-modal input[name="your-wanted-resource"]').val(location);
        $('#gated-resource-modal').modal('show');
    } else {
        window.location = location;
    }
});

document.addEventListener( 'wpcf7mailsent', function( e ) {
    if (e.detail.contactFormId === 56172) {
        if (Cookies.enabled && !Cookies.get('gated-resource-cookie')) {
            Cookies.set('gated-resource-cookie', 'yes');
            console.log(Cookies.get('gated-resource-cookie'));
        }
        window.location = location;
    }
}, false);
